import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pop_wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "popup_cover" }, null, -1)
const _hoisted_3 = { class: "alert_wrapper" }
const _hoisted_4 = { class: "alert_header" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "alert_body" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "alert_footer"
}
const _hoisted_9 = {
  key: 1,
  class: "alert_footer"
}


import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomAlert',
  props: {
    title: {},
    msg: {},
    type: {},
    sCb: {},
    fCb: {}
  },
  setup(__props: any) {

// import { defineProps } from "vue";
const store = useStore();
const props = __props;
// store.commit("closeAlert");
const alertOk = () => {
  if (props.sCb != undefined && props.sCb != null) {
    window.setTimeout(() => {
      props.sCb();
    }, 300);
  }
  closeAlert();
};
const closeAlert = () => {
  if (props.fCb != undefined && props.fCb != null) {
    props.fCb();
  }
  store.commit("closeAlert");
};

//  window.customConfirm({
//           title: "로그인에러",
//           msg: "입력한 아이디 또는 비밀번호가 틀립니다. 다시 입력해주시기 바랍니다.",
//           sCb: function () {
//             loginInfo.value.password = "";
//             pwInput.value.focus();
//           },
//           fCb: function () {
//             loginInfo.value.password = "";
//             pwInput.value.focus();
//           },
//         });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "alert_title",
          innerHTML: props.title
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "alert_text",
          innerHTML: props.msg
        }, null, 8, _hoisted_7)
      ]),
      (props.type == 'alert')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "alert_confirm",
              onClick: alertOk
            }, "확인")
          ]))
        : _createCommentVNode("", true),
      (props.type == 'confirm')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "alert_confirm",
              onClick: alertOk
            }, "확인"),
            _createElementVNode("div", {
              class: "alert_cancel",
              onClick: closeAlert
            }, "취소")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})